import _jsx2 from '@babel/runtime/helpers/esm/jsx';
import { forwardRef, Suspense, lazy } from 'react';
import 'prop-types';
import { isServerSideRendering } from '@dbh/environment';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';
import { jsx } from 'react/jsx-runtime';

/*
 *
 * Constants: `@dbh/react-lazy`.
 *
 */const lazyLoadedComponentDisplayName="LazyComponent";

const DefaultPlaceholderComponent=null,createBrowserOnlyLazyComponent=withConformsTo("createBrowserOnlyLazyComponent",[],(a,b)=>{const c=/*#__PURE__*/lazy(a),d=/*#__PURE__*/forwardRef((a,d)=>{let{shouldLoadChunkAndMount:e,...f}=a;return/*#__PURE__*/_jsx2(Suspense,{fallback:b?/*#__PURE__*/jsx(b,{...f,ref:d}):DefaultPlaceholderComponent},void 0,e?/*#__PURE__*/jsx(c,{...f,ref:d}):null)});return d.displayName=lazyLoadedComponentDisplayName,isServerSideRendering()?()=>null:d});/**
 * Creates a "browser only" (not rendered in server side rendering,
 * `React.Suspense` does not currently support it) component that loads its chunk
 * and renders on demand, when the `shouldLoadChunkAndMount: true` is passed to
 * it. Use it, instead of `makeUniversal`, when you are sure that the component
 * will never need to be rendered in server side rendering.
 * @param {Function} importFunction @example `() => import('./component')`.
 * @param {React.ReactElement} PlaceholderComponent .
 * @return {React.Component} Wrapper, renders `UniversalComponent`.
 */var createBrowserOnlyLazyComponent$1 = createBrowserOnlyLazyComponent;

/**
 * Returns `true` if the component is a lazy component created with
 * `createBrowserOnlyLazyComponent`. Please note that we remove display names
 * in production, so it will always return `false` in that case.
 * @param {Object} Component .
 * @return {boolean} .
 */const isLazyLoadedReactComponent=withConformsTo("isLazyLoadedReactComponent",[],a=>"object"==typeof a&&"function"==typeof a.render&&a.displayName===lazyLoadedComponentDisplayName);var isLazyLoadedReactComponent$1 = isLazyLoadedReactComponent;

export { createBrowserOnlyLazyComponent$1 as createBrowserOnlyLazyComponent, isLazyLoadedReactComponent$1 as isLazyLoadedReactComponent };
